import React from 'react';
import { context } from '../configs';

const defaultState = {
	theme: '', 
	language: 'en', 
	configParams: {}, 
	eventStatusUpdate: null, // for change event status popup
};

let defaultMainContext;
try {
	if(window.localStorage.getItem(context.main)) {
		defaultMainContext = JSON.parse(window.localStorage.getItem(context.main));
	} else {
		defaultMainContext = defaultState;
	}
} catch(err) {
	console.log('No main context found');
	defaultMainContext = defaultState;
}

const mainContext = React.createContext(defaultMainContext);

export {
	defaultMainContext,
	mainContext,
};
